import Vue from 'vue'
import Valid from './valid'
import cookieUtil from './plugin/cookie-util.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
/*import Response from './plugin/ResponseHelper.js'*/
import Utils from './plugin/utils.js'
import { imgcrop } from './plugin/imgcrop'

Vue.use(ElementUI);
Vue.use(Valid);
Vue.use(cookieUtil);
Vue.filter('imgcrop', imgcrop);
Vue.use(VueLazyload,{
  attempt:2,
  listenEvents: [ 'scroll' ],
  adapter: {
    loaded ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
      // do something here
      // example for call LoadedHandler
    },
    loading (listender, Init) {

    },
    error (listender, Init) {

    }
  },
  filter: {
      progressive (listener, options) {
        listener.el.setAttribute('lazy-progressive', 'true');
        if(listener.src && (listener.src.indexOf('x-oss-process')!=-1 || listener.src.indexOf('h_1e_1c_0l')!=-1|| listener.src.indexOf('w_90q_1')!=-1)){
          listener.loading = listener.src;
        }else{
          listener.loading = imgcrop(listener.src,10,10,0);
        }

    },
    webp (listener, options) {
      let uid = listener.el.getAttribute('uid');
      /*if (!options.supportWebp) return;*/
      if(listener.src && (listener.src.indexOf('x-oss-process')!=-1 || listener.src.indexOf('h_1e_1c_0l')!=-1|| listener.src.indexOf('w_90q_1')!=-1)){
        listener.src = listener.src;
      }else{
        if(uid == 0){
          listener.src = imgcrop(listener.src,662,'auto',1);
        }else{
          listener.src = imgcrop(listener.src,210,142,0);
        }

      }
    }
  }
})
/*Vue.use(Response)*/
//注册全局方法
Vue.prototype.$utils=Utils
Vue.prototype.bus = new Vue();
Vue.config.productionTip = false;//关闭生产模式下给出的提示



export default Vue;



// WEBPACK FOOTER //
// ./src/comm.js